import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-cookies-modal',
  imports: [],
  templateUrl: './cookies-modal.component.html',
  styleUrl: './cookies-modal.component.scss'
})
export class CookiesModalComponent {
  _cookieValue: any;
  _isConcent: any = false;
  
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private cookieService: CookieService,
  ) { }

  goToCookies() {
    this.router.navigate(['/cookies'])
  }


  setCookies() {
    const expirationDate = new Date();
    expirationDate.setMonth(expirationDate.getMonth() + 6);
    this._isConcent = true;
    this.cookieService.set('isConcent', 'true', expirationDate, '/');
    this._cookieValue = this.cookieService.get('isConcent');
    this.dialog.closeAll();
  }

}
